import React from 'react';
import { useIntl } from 'react-intl';

import { translations } from '@/locale';
import { getBookedFlights } from '@/services/api/reports';

import useLoad from '@flyblack/common/hooks/useLoad';

import Loading from '@flyblack/common/components/Loading';
import LargeDataDetail from '@flyblack/common/components/LargeDataDetail';
import RowContainer from '@flyblack/common/components/RowContainer';

import OverviewCard from './OverviewCard';

const BookedFlightsCard = () => {
  const intl = useIntl();

  const { value: bookedFlightsReport, loading, error } = useLoad({
    load: getBookedFlights
  });

  return (
    <OverviewCard title={intl.formatMessage({ id: translations.pages.overview.bookedFlights.title })}>
      {loading ? (
        <Loading visible={loading} className="py-9" center>
          <Loading.Indicator size={40} borderWidth={2} />
        </Loading>
      ) : (
        <RowContainer>
          <RowContainer.Item col={6}>
            <LargeDataDetail
              title={intl.formatMessage({ id: translations.pages.overview.bookedFlights.bookedDeals })}
              data={
                error
                  ? intl.formatMessage({ id: translations.pages.overview.errorValue })
                  : bookedFlightsReport.adminEmptyLegs
              }
            />
          </RowContainer.Item>

          <RowContainer.Item col={6}>
            <LargeDataDetail
              title={intl.formatMessage({ id: translations.pages.overview.bookedFlights.bookedShuttles })}
              data={
                error
                  ? intl.formatMessage({ id: translations.pages.overview.errorValue })
                  : bookedFlightsReport.adminJetShuttles
              }
            />
          </RowContainer.Item>
        </RowContainer>
      )}
    </OverviewCard>
  );
};

export default BookedFlightsCard;
